import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BasketItem } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'app-booking-price-changes-modal',
  templateUrl: './booking-price-changes-modal.component.html',
  standalone: false
})
export class BookingPriceChangesModalComponent implements OnInit {
  @Input() item: BasketItem = null;
  type = 'item';
  isScion = false;
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    protected themeService: ThemeService
  ) {}

  ngOnInit(): void {
    // check to see what item is as flight is hardcoded
    this.type = this.item?.service?.type.toLowerCase();
    if (this.themeService.isScionEnv) {
      this.isScion = true;
    }
  }

  close() {
    this.activeModal.close();
    this.router.navigate(['/search']);
  }
}

LightningModalTypes.BookingPriceChangesModalComponent.component = BookingPriceChangesModalComponent;
